<template>
  <div>
    <div class="entete ">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('indexation.title')}}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
            <a class="button is-addOrEdit" @click="save"
               :disabled="indexationYearSelect === null"
               :class="{ 'button-access-no-permission'
               : indexationYearSelect === null}">
              {{ $t('general.button.sauvegarder')}}
            </a>
          </div>
        </div>
      </div>
      <error-msg-component :messages="messages"
                           :error="error"
                           :champsVide="champsVide"
                           :messagesChampsVide="messagesChampsVide"
                           :title="'general.problemOccurred'"
                           :withEmplyFields="true"
                           @close="error = false"/>
      <div>
        <b-field :label="$t('indexation.year')">
          <div class="columns">
            <b-dropdown class="column is-2 disablejustifyCenter
                        dropdownSelect  pdr-0
                            mg-dropdown-content-left-10px
                            setWidth100PercentOfSpan pdb-0
                            dropdown-multiple-background-hover-disabled">
              <template #trigger>
                <qd-button class="border-radius-4px" expanded>
                  <slot>
                    <div class="columns is-vcentered">
                      <span class="column is-10 has-text-left">
                              {{ getInfoYear }}
                      </span>
                      <span class="column is-2 has-text-right">
                              <b-icon icon="chevron-down"></b-icon>
                      </span>
                    </div>
                  </slot>
                </qd-button>
              </template>
              <b-dropdown-item class="lien" @click="createYear()">
                {{ $t('indexation.addYear') }}
              </b-dropdown-item>
              <b-dropdown-item v-for="(indexation, index) in allIndexation" :key="index"
                               @click="updateYear(indexation.annee)">
                {{ indexation.annee }}
                ({{ indexation.dateDebut | formatDate }} - {{ indexation.dateFin | formatDate }})
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </b-field>
      </div>
      <div class="tab mgt-20px mgl-0">
        <ul>
          <li @click="activeTab = 'Produit'"
              :class="{'is-active': activeTab === 'Produit'}">
            {{ $t('indexation.onglet.produit')}}
          </li>
          <li v-if="societeActive.roles.length > 1 || societeActive.roles[0] !== constantes.REGIE"
              @click="activeTab = 'Regie'"
              :class="{'is-active': activeTab === 'Regie'}">
            {{ $t('indexation.onglet.regies')}}
          </li>
          <li @click="activeTab = 'Client'"
              :class="{'is-active': activeTab === 'Client'}">
            {{ $t('indexation.onglet.client')}}
          </li>
        </ul>
      </div>
    </div>
    <component :is="activeTab"
               :societeId="societeActiveId"
               :indexationYearSelect="indexationYearSelect"
               :indexationPreviousYearSelect="indexationPreviousYearSelect"
               @updateIndexation="updateIndexationValue"
               @replaceAllIndexationTiers="replaceAllIndexationTiers"
               @updateIndexationTiersValue="updateIndexationTiersValue"
               @updateSpecialisationTiers="updateSpecialisationTiers"
               @gestionErreur="gestionErreur"
               ref="component"/>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <pop-up-prevention
        :messHeader="$t('indexation.popUpAlerteSauvegarde.' +
        (functionToCall === createYear ? 'titleCreate' : 'titleChange') )"
        :messDescription="$t('indexation.popUpAlerteSauvegarde.sousTitle', {
          year: actualYearSelect
        })"
        :cancel="$t('indexation.actions.continuWithoutSave')"
        :validate="$t('indexation.actions.saveAndContinu')"
        :previousButton="$t('general.button.cancel')"
        @previousButton="closePopUpPrevention"
        @yes="save"
        @no="goTo"
      />
    </b-modal>
    <b-modal v-model="popUpAddIndexation"
             has-modal-card
             class="modal">
      <pop-up-add-indexation :societe-id="societeActiveId"
                             @reloadAndUpdateYearSelected="reloadAndUpdateYearSelected">
      </pop-up-add-indexation>
    </b-modal>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import Breadcrumb from '@/components/general/breadcrumb';
import { getAll, update } from '@/api/indexation';
import messageErreur from '@/services/general/messageErreur';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import checkUpdateOrNotIndexation
  from '@/services/parametrage/indexation/checkUpdateOrNotIndexation';
import PopUpPrevention from '@/components/general/popUpPrevention';
import PopUpAddIndexation from '@/components/parametrage/indexation/p_addIndexation';
import Produit from '@/components/parametrage/indexation/onglet/produit';
import Regie from '@/components/parametrage/indexation/onglet/regie';
import Client from '@/components/parametrage/indexation/onglet/client';
import messageSucces from '@/services/general/messageSucces';
import formatDate from '@/services/general/formatDate';
import validationGeneral from '@/services/validation/validation';
import validationIndexation from '@/services/parametrage/indexation/validation';
import translate from '@/services/parametrage/indexation/translate';
import ErrorMsgComponent from '@/components/general/errorMsgComponent';
import genererIndexationTiers from '@/services/parametrage/indexation/genererIndexationTiers';
import { TIERS_TYPE_FOURNISSEUR } from '@/configuration/tiers/tiersConf';
import { REGIE } from '@/configuration/societe/societe';

const Societe = createNamespacedHelpers('societe');

export default {
  data() {
    return {
      activeTab: 'Produit',
      actualYearSelect: null,
      allIndexation: [],
      indexationYearSelect: null,
      indexationPreviousYearSelect: null,
      popUpPrevention: false,
      functionToCall: null,
      popUpAddIndexation: false,
      yearSave: null,
      error: false,
      champsVide: [],
      messagesChampsVide: [],
      messages: [],
      constantes: {
        REGIE,
      },
    };
  },
  components: {
    Breadcrumb,
    PopUpPrevention,
    PopUpAddIndexation,
    Produit,
    Regie,
    Client,
    ErrorMsgComponent,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
    }),
    getInfoYear() {
      if (!this.actualYearSelect) return '';
      const yearInfo = this.allIndexation.find((ind) => {
        return Number(ind.annee) === Number(this.actualYearSelect);
      });
      if (!yearInfo) return '';
      return yearInfo.annee + ' (' + formatDate(yearInfo.dateDebut) + ' - ' + formatDate(yearInfo.dateFin) + ')';
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('general.breadcrumb.parametrage'), route: { name: 'l.parametrage.general' }, isActive: false },
        { title: this.$t('indexation.breadcrumb.title'), route: { name: '' }, isActive: true },
      ];
    },
  },
  methods: {
    closePopUpPrevention() {
      this.actualYearSelect = this.yearSave;
      this.popUpPrevention = false;
      this.functionToCall = null;
    },
    updateIndexationValue(propriete, value) {
      this.indexationYearSelect[propriete] = value;
    },
    updateYear(year) {
      this.yearSave = null;
      if (year === this.actualYearSelect) return;
      if (!checkUpdateOrNotIndexation(this.indexationYearSelect, this.allIndexation.find((ind) => {
        return this.indexationYearSelect && ind.annee === this.indexationYearSelect.annee;
      }))) {
        this.popUpPrevention = true;
        this.functionToCall = this.updateValue;
        this.yearSave = cloneDeep(this.actualYearSelect);
        this.actualYearSelect = year;
        return;
      }
      this.actualYearSelect = year;
      this.updateValue();
    },
    async updateValue() {
      await this.updateIndexationSelect(this.actualYearSelect);
      this.$refs.component.updateValueBase();
    },
    updateIndexationSelect(year) {
      if (!this.allIndexation || this.allIndexation.length === 0) {
        this.actualYearSelect = null;
        return;
      }
      this.indexationYearSelect = cloneDeep(this.allIndexation.find((ind) => {
        return Number(ind.annee) === Number(year);
      }));
      if (!this.indexationYearSelect) this.indexationYearSelect = cloneDeep(this.allIndexation[0]);
      const previousYear = Number(this.indexationYearSelect.annee) - 1;
      this.indexationPreviousYearSelect = cloneDeep(this.allIndexation.find((ind) => {
        return ind.annee === previousYear;
      }));
      this.actualYearSelect = this.indexationYearSelect.annee;
    },
    replaceAllIndexationTiers(newIndexationTiers, typeToSave) {
      this.indexationYearSelect.indexationTiers = cloneDeep(
        this.indexationYearSelect.indexationTiers.filter((indexation) => {
          return indexation.tiersType === typeToSave;
        }),
      );
      this.indexationYearSelect.indexationTiers = this.indexationYearSelect.indexationTiers
        .concat(newIndexationTiers);
      this.$refs.component.updateValueBase();
    },
    updateIndexationTiersValue(taux, tiersId) {
      const infoIndexation = this.indexationYearSelect.indexationTiers.find((ind) => {
        return ind.tiersId === tiersId && ind.specialisationTiersId === null;
      });
      if (!infoIndexation) return;
      infoIndexation.pourcentageIndexationParDefaut = taux;
    },
    updateSpecialisationTiers(tiers, newListeIndexationTiersSpe) {
      const indexatonTiers = this.indexationYearSelect.indexationTiers.filter((ind) => {
        return ind.tiersId !== tiers.tiersId
          || (ind.tiersId === tiers.tiersId && !ind.specialisationTiersId);
      });
      const list = [];
      newListeIndexationTiersSpe.forEach((ind) => {
        const newIndexation = genererIndexationTiers();
        newIndexation.indexationId = this.indexationYearSelect.id;
        newIndexation.tiersType = TIERS_TYPE_FOURNISSEUR;
        newIndexation.tiersId = tiers.tiersId;
        newIndexation.specialisationTiersId = ind.specialisationTiersId;
        newIndexation.tiers.nomCommercial = tiers.nomCommercial;
        newIndexation.specialisationTiers.nomCommercial = ind.specialisationTiersNomCom;
        newIndexation.pourcentageIndexationParDefaut = ind.taux;
        list.push(newIndexation);
      });
      this.indexationYearSelect.indexationTiers = indexatonTiers.concat(list);
    },
    goTo() {
      this.functionToCall(true);
      this.popUpPrevention = false;
    },
    async save() {
      if (this.indexationYearSelect === null) return;
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.error = false;
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        await update(this.indexationYearSelect);
        await this.getAllYears();
        await this.updateIndexationSelect(this.actualYearSelect);
        if (this.functionToCall) this.functionToCall();
        this.popUpPrevention = false;
        this.functionToCall = null;
        loadingComponent.close();
        messageSucces(this.$i18n.t('indexation.message.success.update'));
      } catch (e) {
        this.gestionErreur(e);
        loadingComponent.close();
        throw e;
      }
    },
    gestionErreur(e) {
      this.error = false;
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      if (e.response && e.response.data.error.validationErrors) {
        validationGeneral(this.$i18n, e.response, this.champsVide,
          this.messages, this.messagesChampsVide, translate);
        validationIndexation(e.response, this.messages);
        this.error = true;
      } else messageErreur(this.$i18n);
    },
    createYear(forceCreation) {
      this.functionToCall = null;
      this.popUpAddIndexation = false;
      this.yearSave = null;
      if (!forceCreation
        && !checkUpdateOrNotIndexation(this.indexationYearSelect, this.allIndexation.find((ind) => {
          return this.indexationYearSelect && ind.annee === this.indexationYearSelect.annee;
        }))) {
        this.popUpPrevention = true;
        this.functionToCall = this.createYear;
        this.yearSave = this.actualYearSelect;
        return;
      }
      this.functionToCall = null;
      this.popUpPrevention = false;
      this.popUpAddIndexation = true;
    },
    async reloadAndUpdateYearSelected(newYear) {
      this.popUpAddIndexation = false;
      await this.getAllYears();
      this.actualYearSelect = newYear;
      await this.updateValue();
    },
    async getAllYears() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const params = {
          limit: NO_PAGINATION,
          query: {
            societeId: this.societeActiveId,
          },
          orderBy: 'annee',
        };
        this.allIndexation = (await getAll(params)).data.result.items;
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  async mounted() {
    this.setInformationPage(this.$t('pageParametrage.indexation.liste'));
    this.actualYearSelect = moment().format('YYYY');
    await this.getAllYears();
    await this.updateValue();
  },
};

</script>
